import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Icon } from '../ui/Icon';
import { findNavItem } from './navItems';
import '../ui/ui.css';
import '../../pages/pages.css';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Toolbar controls for the whole page (refresh, create, export). */
  actions?: ReactNode;
}

/**
 * Page title block.
 *
 * The icon and its hue are read from the nav model for the current route rather
 * than passed in, so a module's colour is defined once and the rail, the
 * breadcrumb and this header can never disagree about it.
 */
export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  const { pathname } = useLocation();
  const item = findNavItem(pathname);

  return (
    <header className="page__header">
      <div className="page__heading">
        {item ? (
          <span className={`ui-icon-chip ui-icon-chip--lg ui-icon-chip--${item.tone}`}>
            <Icon name={item.icon} size="lg" />
          </span>
        ) : null}
        <div>
          <h1 className="page__title">{title}</h1>
          {subtitle ? <p className="page__subtitle">{subtitle}</p> : null}
        </div>
      </div>
      {actions ? <div className="page__header-actions">{actions}</div> : null}
    </header>
  );
}
